import { ApiLogLevel } from './api-log-level.enum';

export class LogConfigModel {
  serverLoggingUrl: string;
  serverLogLevel: ApiLogLevel;
}
